/**
 * Languages Repository
 * Handles business logic for fetching languages
 */

import { LanguagesApi } from './languages-api';
import { LanguageItem } from '../types/languages-types';

export class LanguagesRepository {
  constructor(private api: LanguagesApi) {}

  /**
   * Fetch active languages sorted by sortOrder
   */
  async getAvailableLanguages(): Promise<LanguageItem[]> {
    const response = await this.api.getApplicationLanguages();

    if (!response.isSuccess || !response.languages) {
      throw new Error(response.errorMessage || 'Failed to fetch languages');
    }

    // Filter active languages and sort by sortOrder
    return response.languages
      .filter(lang => lang.isActive)
      .sort((a, b) => a.sortOrder - b.sortOrder);
  }
}
